import { BrowserView, MobileView, } from 'react-device-detect';

import NavbarDesktop from './NavbarDesktop'
import NavbarMobileTop from './NavbarMobileTop';


export default function Navbar({ showSearch = false }: { showSearch?: boolean }) {
    return (
        <header style={{ display: 'contents' }}>
            <BrowserView renderWithFragment>
                <NavbarDesktop />
            </BrowserView>
            <MobileView renderWithFragment>
                <NavbarMobileTop showSearch={showSearch} />
            </MobileView>
        </header>
    )
}
